"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryTokenIntents = void 0;

var _common = require("./../common");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryTokenIntents = new _CrudBuilder.CrudBuilder(class BasisTheoryTokenIntents extends _service.BasisTheoryService {
  constructor(options) {
    const _options = options; // eslint-disable-next-line unicorn/prefer-spread

    _options.transformRequest = [].concat(_common.transformTokenRequestSnakeCase, options.transformRequest || []); // eslint-disable-next-line unicorn/prefer-spread

    _options.transformResponse = [].concat(_common.transformTokenResponseCamelCase, options.transformResponse || []);
    super(_options);
  }

}).create().delete().build();
exports.BasisTheoryTokenIntents = BasisTheoryTokenIntents;